/** Persisted Cloud discriminator (Biz / meta). */
export const WHATSAPP_API_CHANNEL = "whatsapp-api";

/** UI modal id — never send to Biz as channel. */
export const WHATSAPP_API_UI_ID = "whatsapp_api";

/** Persisted Messenger Page discriminator (Biz / messenger-api). */
export const MESSENGER_PAGE_CHANNEL = "messenger-page";

/** UI modal id — never send to Biz as channel. */
export const MESSENGER_PAGE_UI_ID = "messenger";

/** Persisted Instagram DM discriminator (Biz / meta-api). */
export const INSTAGRAM_DM_CHANNEL = "instagram-dm";

/** UI modal id — never send to Biz as channel. */
export const INSTAGRAM_UI_ID = "instagram";

export function isWhatsappApiChannel(channel) {
  return channel === WHATSAPP_API_CHANNEL;
}

export function isMessengerPageChannel(channel) {
  return channel === MESSENGER_PAGE_CHANNEL;
}

export function isInstagramDmChannel(channel) {
  return channel === INSTAGRAM_DM_CHANNEL;
}

export function isClassicWhatsappChannel(channel) {
  return channel === "whatsapp";
}

export function toPersistedChannel(channel) {
  if (channel === WHATSAPP_API_UI_ID || channel === WHATSAPP_API_CHANNEL) {
    return WHATSAPP_API_CHANNEL;
  }
  if (channel === MESSENGER_PAGE_UI_ID || channel === MESSENGER_PAGE_CHANNEL) {
    return MESSENGER_PAGE_CHANNEL;
  }
  if (channel === INSTAGRAM_UI_ID || channel === INSTAGRAM_DM_CHANNEL) {
    return INSTAGRAM_DM_CHANNEL;
  }
  return channel;
}

export function shouldShowQrForConnection(channel, status) {
  if (
    isWhatsappApiChannel(channel) ||
    isMessengerPageChannel(channel) ||
    isInstagramDmChannel(channel) ||
    channel === "webchat"
  ) {
    return false;
  }
  return status === "qrcode";
}
